<template>
  <div class="station-survey">
    <section class="station-survey__header">
      <div class="station-survey__header__title-wrapper">
        <h2 class="station-survey__header__title">
          <span class="station-survey__header__title-icon">
            <font-awesome-icon :icon="['custom', 'station']" />
            <font-awesome-icon :icon="['far', 'check-circle']" />
          </span>
          <span>STATION SURVEY</span>
        </h2>
        <h3 class="station-survey__header__title--subtitle">
          <span class="station-survey__header__title-icon">
            <font-awesome-icon :icon="['custom', 'station']" />
            <font-awesome-icon :icon="['far', 'check-circle']" />
          </span>
          <span>Select a Station to begin </span>
        </h3>
      </div>
    </section>

    <section class="station-survey__stations">
      <mini-stations-element
        :stations="computedStations"
        :highlighted-stations="surveyedStations"
        :selected-station-st-id="selectedStationData.StId"
        @stationClicked="stationClicked"
      />
    </section>

    <section class="station-survey__station">
      <div class="station-survey__station-wrapper">
        <div class="station-survey__station__header">
          <!-- <button
            type="button"
            class="g-btn g-btn--rounded"
            @click="restartStation()"
          >
            Restart Station
          </button> -->
          <!-- <button
            type="button"
            class="g-btn g-btn--rounded"
            @click="setFaultStatus()"
          >
            <font-awesome-icon
              :icon="['fas', 'dot-circle']"
              style="color: red"
            />
            Fault Toggle
          </button> -->
        </div>

        <div class="station-survey__station__station-component-wrapper">
          <button
            class="g-btn g-btn--station"
            :class="{'g-btn--disabled': !(selectedStationData && selectedStationData.StId > 1)}"
            @click.stop="setStationFromStId(parseInt(selectedStationData.StId) - 1)"
          >
            <span class="g-btn--station__text">
              <font-awesome-icon :icon="['fas', 'chevron-left']" />
            </span>
          </button>
          <station-component
            v-bind="{Data: selectedStationData, Type: 'survey'}"
            :store="store"
          />
          <button
            class="g-btn g-btn--station"
            :class="{'g-btn--disabled': !(selectedStationData && selectedStationData.StId < computedStations.length)}"
            @click.stop="setStationFromStId(parseInt(selectedStationData.StId) + 1)"
          >
            <span class="g-btn--station__text">
              <font-awesome-icon :icon="['fas', 'chevron-right']" />
            </span>
          </button>
        </div>

        <div class="station-survey__station__station-status">
          {{ stationMessage }}
        </div>


        <div class="station-survey__information">
          <flow-gauge-component :store = "store" />
          <div class="station-survey__information">
            <voltage-gauge-component
              :socket-message = "SocketMessage"
              :voltage = "store.getData('voltage')"
            />
            <current-gauge-component
              :socket-message = "SocketMessage"
              :current = "store.getData('current')"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import _ from 'lodash'
import StationComponent from '@/components/StationComponent'
import CurrentGauge from '@/components/CurrentGauge.vue'
import VoltageGauge from '@/components/VoltageGauge.vue'
import FlowGauge from '@/components/FlowGauge.vue'
// import SliderElement from '@/components/elements/SliderElement.vue'
import MiniStationsElement from '@/components/elements/MiniStationsElement.vue'

export default {
  name: 'StationSurvey',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    'station-component': StationComponent,
    'current-gauge-component': CurrentGauge,
    'voltage-gauge-component': VoltageGauge,
    'flow-gauge-component': FlowGauge,
    'mini-stations-element': MiniStationsElement
  },
  mixins: [SocketHandler, LifeCycle],
  props: {
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    SocketMessage:
    {
      type: Object,
      default: function() {
        return{}
      }
    },
    ControllerMode: {
      type: String,
      default: null
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return {
      stationMessage: 'Select a Station to begin',
      stationMessages: {
        select: 'Select a Station to begin',
        restarting: 'Restarting Station',
        starting: 'Starting Station',
        started: 'Station Started',
        stopped: 'Stopped Station',
      },
      remainTime: 0,
      surveyedStations: [],
      selectedStationData: {},
      sliderData: {
        elementPosition: 0
      },
    }
  },
  computed: {
    computedStations() {
      const stations = this.store.getData('stations')
      let rtn = stations

      if(this.$route.query.stations && this.$route.query.stations !== '') { // get query list
        rtn = this.$route.query.stations.split(',') // turn query into array
        rtn = rtn.map(stationID => stations.find(station => station.StId === stationID)) // find actual stations
      }

      return rtn
    },
    computedStationStatus() {
      return this.selectedStationData.isRunning
    }
  },
  watch: {
    computedStationStatus(status) {
      // if(status) {
      //   this.surveyedStations.push(this.selectedStationData.StId) // should only be added when confirmed
      // }
      this.stationMessage = status ? this.stationMessages.started : this.stationMessages.stopped
    },
    selectedStationData(newVal, oldVal) {
      if(newVal.Id !== oldVal.Id) { // not same station getting modified :)
        this.stationMessage = this.stationMessages.starting
      }
      
      const index = this.surveyedStations.indexOf(this.selectedStationData.StId)
      if(index !== -1) {
        this.restartStation()
      } else {
        this.startStation(newVal.StId)
      }
    }
  },
  mounted() {
    this.$emit('SetPageMessage', {
      target: 'FooterButtons',
      data: [{
        label: 'Refresh',
        route: '/stations',
        className: 'ButtonLeft'
      },
      {
        label: 'Station Survey',
        target: 'survey-open-dialogue-modal',
        // route: '/survey',
        className: 'ButtonLeft'
      },
      {
        label: 'Sensor List',
        route: '',
        className: 'ButtonLeft'
      },
      {
        label: 'Map View',
        route: '',
        className: 'ButtonLeft'
      }]
    })
    this.$nextTick(() => {
      this.$emit('SetPageMessage', {
        target: 'FooterButtons',
        data: [{
          label: this.$tc('messages.sharedTexts.stations.station', 0),
          route: '/stations',
          className: 'ButtonLeft'
        }/*,
        {
          label: this.$t('messages.footer.sensorList'),
          route: '/sensors',
          className: 'ButtonLeft'
        },
        {
          label: this.$t('messages.footer.mapView'),
          route: '/maps',
          className: 'ButtonLeft'
        }*/]
      })
    })
  },
  destroyed() {
    this.SocketMessageSend({component: 'Survey', command: 'Destroyed'})
  },
  methods: {
    /* REFACTOR CODE */
    startStation(stationStId) {
      this.SocketMessageSend({
        component: 'Survey',
        command: 'Start',
        id: parseInt(stationStId, 10),
        time: 600
      })
    },
    restartStation() {
      const index = this.surveyedStations.indexOf(this.selectedStationData.StId)

      this.stationMessage = this.stationMessages.restarting

      if(index !== -1) this.surveyedStations.splice(index, 1)

      this.startStation(this.selectedStationData.StId)
    },
    stationClicked(station) {
      this.selectedStationData = station
    },
    setStationFromStId(StId) {
      const stationData = this.computedStations.find(station => station.StId === String(StId))

      if(stationData) {
        this.selectedStationData = stationData
      } else {
        console.warn('setStationFromStId', 'could not find station from StId with', StId)
      }
    },
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    setFaultStatus() {
      if(this.selectedStationData.StId !== undefined) {
        const status = (this.selectedStationData.status === '1') ? '0' : '1'
        this.selectedStationData.status = status
        this.SocketMessageSend({Category: 'Stations', Type: 'StationData', Oper: 'Upd', Seq: this.selectedStationData.StId, Status: status})
      } else {
        console.warn('no station selected')
      }
    },
    setSelectedStationData(station) {
      this.$set(this.selectedStationData, station)
    },
    getStationButtonStatusClass(station) {
      let rtnClass = ''

      if(station.status === '1') {
        rtnClass = 'g-btn--station--error'
      } else if(this.surveyedStations.indexOf(station.StId) !== -1) {
        rtnClass = 'g-btn--station--active'
      }
      return rtnClass
    }
  }
}
</script>

<style lang="scss">
  .station-survey {
    @include clearfix();
    max-width: $bp-desktop-large;
    margin: clamp(75px, 10vw, 150px) auto;
    display: grid;
    grid-template-columns: 0.4fr 0.6fr;
    grid-template-areas:
    "survey-header survey-header"
    "survey-station survey-station"
    "survey-stations survey-stations"
    ;

    section {
      @include clearfix();
      background-color: white;
      // Margin handling here isn't very... intuitive, but will have to do for now //TR
      margin: $application-base-padding $application-base-padding 0;
      padding: $application-base-padding;
    }

    &__flow {
      font-size: 14px;
      margin: 10px;
    }

    &__header {
      grid-area: survey-header;

      &__title:not(:first-child) {
        margin: 5px 10px;
      }

      &__title-icon, &__title-icon * {
        display: inline-block;
        height: 20px;
        font-size: 20px;
      }
    }
    
    &__information {
      margin-top: 30px;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      align-items: center;
      justify-content: space-around;
      width: 100%;
    }

    &__stations {
      grid-area: survey-stations;
      height: 100%;
      // max-height: 300px;
      overflow-y: scroll;
      overflow-x: hidden;
      &__list {
        display: none;

        &--slider { // Mobile list
          display: block;
        }
      }
    }

    &__station {
      grid-area: survey-station;
      display: flex;
      justify-content: center;
      height: 100%;

      .station {
        transform: scale(0.85);
        margin: 10px -10px;
        display: flex;
        justify-content: space-between;
        height: 100%;
      }

      &__station-component-wrapper {
        // display: flex;
        // justify-content: space-between;
        // align-items: center;

        .g-btn.g-btn--station.g-btn--disabled {
          opacity: 0.5;
          background: $color-grey !important;
          transition: background 1s;
          span {
            display: none;
          }
        }
      }

      &-wrapper {
        @include clearfix();
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      &__header {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
      &__station-status {
        box-sizing: border-box;
        margin-top: 10px;
        width: 100%;
        padding: $application-base-padding;
        border: 1px solid $color-grey-darker;
        text-align: center;
      }
    }
  }
  @media screen and (min-width: $bp-mobile) {
    .station-survey {
      &__station {
        &-wrapper {
          width: 100%;
          max-width: 80%;
        }
        &__station-component-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .station {
          transform: none;
          margin: 20px;
        }
      }
    }
  }

  @media screen and (min-width: $bp-tablet) {
    .station-survey {
      display: grid;
      grid-template-columns: 0.4fr 0.6fr;
      grid-template-areas:
      "survey-header survey-header"
      "survey-station survey-station"
      "survey-stations survey-stations"
      ;

      &__flow {
        transform: translate3d(50%, -30px, 0);
        margin: 0;
      }

      &__stations {
        &__list {
          box-sizing: border-box;
          padding: 5px;
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(54px, 1fr));
          grid-gap: 9px;

          &--slider { // Mobile list
            display: none;
          }
        }
      }
    }
  }

  @media screen and (min-width: $bp-desktop) {
    .station-survey {
      display: grid;
      grid-template-columns: 0.4fr 0.6fr;
      grid-template-areas:
      "survey-header survey-header"
      "survey-stations survey-station"
      ;

      &__station {
        margin-left: 0px !important;
      }
    }
  }
</style>